import gql from "graphql-tag";

export default gql`
  subscription SubscribeToSiloStatus {
    subscribeToSiloStatus {
      inventoryLocationId
      status
    }
  }
`;
